/**
 * AppContent — renderiza las rutas definidas en App.tsx (las réplica).
 */

import React from 'react'
import { Outlet } from 'react-router-dom'
import { CContainer } from '@coreui/react'
import BarraPrueba from './BarraPrueba'

const AppContent = () => {
  return (
    // fluid (no `lg`): el contenido SIEMPRE llena el espacio disponible
    // (sidebar 256px → 64px → oculto) sin centrarse ni dejar margen derecho.
    // El CContainer lg capaba en max-width 1320px → al colapsar el sidebar el
    // contenido quedaba centrado con margen a la derecha.
    <CContainer fluid className="px-4">
      {/* Franja amarilla del período de PRUEBA (empresa sin plan pago). */}
      <BarraPrueba />
      <Outlet />
    </CContainer>
  )
}

export default React.memo(AppContent)
